import { GitBranch, Rocket, Globe, Repeat } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const features = [
  {
    Icon: GitBranch,
    title: 'Dual-Regulated Presence',
    desc: 'Authorized in both DIFC (DFSA) and ADGM (FSRA), giving issuers flexibility in jurisdiction selection and SPV domiciliation.',
  },
  {
    Icon: Rocket,
    title: 'Technology-Driven Execution',
    desc: 'Proprietary analytics and digital platforms for pricing, investor targeting, and real-time transaction monitoring that accelerate time-to-market.',
  },
  {
    Icon: Globe,
    title: 'Global Investor Network',
    desc: 'Direct relationships with institutional investors, sovereign wealth funds, family offices, and Islamic finance mandates across GCC, Asia, Europe, and North America.',
  },
  {
    Icon: Repeat,
    title: 'Full-Cycle Commitment',
    desc: "From preliminary advisory through post-issuance management, we remain engaged through every phase of your bond's lifecycle.",
  },
];

const metrics = [
  { number: '100%', label: 'Regulatory Compliance' },
  { number: '24/7', label: 'Market Monitoring' },
  { number: '48hr', label: 'Initial Assessment' },
  { number: '15+', label: 'Years Experience' },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-20 sm:py-28" style={{ backgroundColor: '#0a1628' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left */}
          <div>
            <ScrollReveal>
              <p className="text-sm font-inter font-semibold uppercase tracking-wider mb-3" style={{ color: '#c9a84c' }}>
                Why ALC Bond
              </p>
              <h2 className="font-playfair font-bold text-3xl sm:text-4xl text-white mb-6">
                Structuring Excellence.<br />Institutional Reliability.
              </h2>
              <p className="font-inter text-base leading-relaxed mb-10" style={{ color: '#9ca3af' }}>
                ALC Bond combines deep regulatory expertise in DIFC and ADGM with cutting-edge financial technology to deliver bond structuring that is precise, efficient, and aligned with both conventional and Islamic finance principles.
              </p>
            </ScrollReveal>

            <div className="space-y-6">
              {features.map((feat, i) => (
                <ScrollReveal key={feat.title} delay={i * 100}>
                  <div className="flex gap-4" data-testid={`why-us-feature-${i}`}>
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: '#0f2240', border: '1px solid rgba(255,255,255,0.1)' }}
                    >
                      <feat.Icon className="w-5 h-5" strokeWidth={1.5} style={{ color: '#c9a84c' }} />
                    </div>
                    <div>
                      <h3 className="font-inter font-semibold text-white text-base mb-1">{feat.title}</h3>
                      <p className="font-inter text-sm leading-relaxed" style={{ color: '#9ca3af' }}>{feat.desc}</p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>

          {/* Right - Metrics */}
          <div className="grid grid-cols-2 gap-4 content-center">
            {metrics.map((metric, i) => (
              <ScrollReveal key={metric.label} delay={i * 100}>
                <div
                  className="p-6 sm:p-8 rounded-xl text-center"
                  style={{ backgroundColor: '#0f2240', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px' }}
                  data-testid={`why-us-metric-${i}`}
                >
                  <div className="font-playfair font-bold text-3xl sm:text-4xl mb-2" style={{ color: '#c9a84c' }}>
                    {metric.number}
                  </div>
                  <div className="text-sm font-inter" style={{ color: '#9ca3af' }}>{metric.label}</div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
